module.exports = __webpack_public_path__ + "src/img/customerLogo.d28bda03.png";